export const removeFamilyNumberFromFamilyNameRegex = new RegExp(
    '(\\d+(\\.\\d+)*\\s-\\s)',
    'g'
)
export const isNumbersOnly = new RegExp(/[^0-9]+/, 'g')
export const isMO = new RegExp(/\+/, 'g')
export const isMOOption = new RegExp(/\(\+\)/, 'g')

export const validateFamilyNumber = (value: string) => {
    const familyNumber = value?.split('.')
    return (
        familyNumber[0]?.trim()?.replace(isNumbersOnly, '').length === 6 &&
        (!familyNumber[1] ||
            familyNumber[1]?.trim()?.replace(isNumbersOnly, '').length <= 2)
    )
}
